import React, { useState } from "react";
import { Calendar } from "react-calendar";
// import DatePicker from "react-date-picker";
import TimePicker from "rc-time-picker-date-fns";
import "rc-time-picker-date-fns/assets/index.css";
import { useNavigate } from "react-router-dom";
import moment from "moment/moment";

// import Multiselect from "multiselect-react-dropdown";
import PageLoader from "../../../components/UI/loader/PageLoader";
import { useDispatch, useSelector } from "react-redux";
import {
  addMentorAvailableSlots,
  meetingData,
  clearState,
} from "../../../reducers/meetingSlice";
import { useEffect } from "react";

//temp
import ErrorToast from "../../../components/Toast/ErrorToast";
import ToastMessage from "../../../components/Toast/ToastComponent";

const CreateMentorCallSlots = () => {
  // const [interviewer, selectInterview] = useState("");
  const [dateType, setDateType] = useState(1); // 1= date range, 2= indefinetly
  const [selectedWeekDays, setSelectedWeekDays] = useState([]);
  //temp
  const [selectedProgram, setSelectedProgram] = useState("");
  const [selectedInterviewer, setSelectedInterviewer] = useState("");
  // const [daysIntoFuture, setDaysIntoFuture] = useState(0);

  //toast states
  const [isShowError, setIsShowError] = useState(false);
  const [errMessage, setErrMessage] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);

  const now = new Date(moment().hour(0).minute(0));

  const [withinDateRange, setWithinDateRange] = useState({
    from: "",
    to: "",
  });

  const [interviewTime, setInterviewTime] = useState({
    sun: [{ from: now, to: now }],
    mon: [{ from: now, to: now }],
    tue: [{ from: now, to: now }],
    wed: [{ from: now, to: now }],
    thru: [{ from: now, to: now }],
    fri: [{ from: now, to: now }],
    sat: [{ from: now, to: now }],
  });

  // const [dateRangeTime, setDateRangeTime] = useState([]);

  useEffect(() => {
    const InBetweenDays = Math.abs(
      (new Date(withinDateRange.from).getTime() -
        new Date(withinDateRange.to).getTime()) /
        (1000 * 60 * 60 * 24)
    );
    const daysInAWeek = ["sun", "mon", "tue", "wed", "thru", "fri", "sat"];
    if (withinDateRange.to !== "") {
      if (InBetweenDays <= 6) {
        setSelectedWeekDays([]);
        // console.log("Yes");
        for (let i = 0; i <= InBetweenDays; i++) {
          if (i > 6) break;
          const day = new Date(
            moment(withinDateRange.from).add(i, "day")
          ).getDay();
          setSelectedWeekDays((prev) => [...prev, daysInAWeek[day]]);
        }
      } else {
        setSelectedWeekDays(daysInAWeek);
      }
    }
  }, [withinDateRange]);

  const [timeRangeCount, setTimeRangeCount] = useState({
    mon: [0],
    tue: [0],
    wed: [0],
    thru: [0],
    fri: [0],
    sat: [0],
    sun: [0],
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const format = "h:mm a";

  const [value, onChange] = useState();

  const { isFetching, isSuccess, isError, errorMessage } =
    useSelector(meetingData);

  const handleTimeSlotRemove = (type, index) => {
    if (interviewTime[type].length === 1) {
      setSelectedWeekDays((prev) => prev.filter((day) => day !== type));
    } else {
      const timeSlots = interviewTime[type];
      const timeSlot = timeRangeCount[type];
      timeSlot.splice(index, 1);
      timeSlots.splice(index, 1);
      setTimeRangeCount((prev) => ({ ...prev, [type]: [...timeSlot] }));
      setInterviewTime((prev) => ({ ...prev, [type]: [...timeSlots] }));
    }
  };

  // const handleRangeTimeRemove = (e, index) => {
  //   const timeSlots = dateRangeTime;
  //   const timeSlot = dateRangeTimeCount;
  //   timeSlot.splice(index, 1);
  //   timeSlots.splice(index, 1);
  //   setDateRangeTime([...timeSlots]);
  //   setDateRangeTimeCount([...timeSlot]);
  // }

  const handleTimeFromChange = (e, type, i) => {
    const value = e;
    const timeSlot = interviewTime[type];
    timeSlot[i].from = value;
    setInterviewTime((prev) => ({ ...prev, [type]: [...timeSlot] }));
  };

  const handleTimeToChange = (e, type, i) => {
    const value = e;
    const timeSlot = interviewTime[type];
    timeSlot[i].to = value;
    setInterviewTime((prev) => ({ ...prev, [type]: [...timeSlot] }));
  };

  // const handleRangeTimeFromChange = (e, i) => {
  //   const value = e;
  //   const timeSlot = dateRangeTime;
  //   timeSlot[i].from = value;
  //   setDateRangeTime([...timeSlot]);
  // }

  // const handleRangeTimeToChange = (e, i) => {
  //   const value = e;
  //   const timeSlot = dateRangeTime;
  //   timeSlot[i].to = value;
  //   setDateRangeTime([...timeSlot]);
  // }
  const handleCheckboxChange = (type) => {
    const arr = selectedWeekDays;
    if (arr.includes(type)) {
      const i = arr.indexOf(type);
      arr.splice(i, 1);
      setSelectedWeekDays([...arr]);
    } else {
      setSelectedWeekDays((prev) => [...prev, type]);
    }
  };

  const validate = () => {
    if (withinDateRange.from === "" || withinDateRange.to === "") return "date";
    //temp
    // if (selectedProgram === "") return "program";
    // if (
    //   localStorage.getItem("adminId") ===
    //     "3b19fa50-b1ff-4216-93bf-c786f8d8cd95" &&
    //   selectedInterviewer === ""
    // )
    //   return "interviewer";

    if (selectedWeekDays.length === 0) return "noSlot";
    let check = "";
    selectedWeekDays.forEach((day) => {
      interviewTime[day].forEach((time) => {
        if (
          new Date(time.from).getTime() + 1200000 >
          new Date(time.to).getTime()
        ) {
          check = "time";
        }
      });
    });
    return check;
  };

  const handleSave = () => {
    if (validate()) {
      if (validate() === "date") {
        setIsShowError(true);
        setErrMessage("Please select a date range!");
      }
      //temp
      // if(validate() === "program") {
      //   setIsShowError(true);
      //   setErrMessage("Please select program!");
      // }
      // if(validate() === "interviewer") {
      //   setIsShowError(true);
      //   setErrMessage("Please select an interviewer!");
      // }

      if (validate() === "time") {
        setIsShowError(true);
        setErrMessage("Time slots should have atleast 30 min difference!");
      }
      if (validate() === "noSlot") {
        setIsShowError(true);
        setErrMessage("Please select a day for availablity!");
      }
    } else {
      let obj;
      obj = interviewTime;
      for (const day in interviewTime) {
        if (!selectedWeekDays.includes(day)) {
          obj = { ...obj, [day]: [] };
        } else {
          const din = obj[day];
          din.map((time) => {
            time.from = moment(time.from).format("HH:mm:ss");
            time.to = moment(time.to).format("HH:mm:ss");
          });
          obj = { ...obj, [day]: [...din] };
        }
      }
      const object = {
        //temp
        programId: selectedProgram,

        adminId:
          localStorage.getItem("adminId") ===
          "3b19fa50-b1ff-4216-93bf-c786f8d8cd95"
            ? selectedInterviewer
            : localStorage.getItem("adminId"),
        dateRange: withinDateRange,
        interviewTime: obj,
      };
      // console.log(object)
      dispatch(addMentorAvailableSlots(object));
      setTimeRangeCount({
        mon: [0],
        tue: [0],
        wed: [0],
        thru: [0],
        fri: [0],
        sat: [0],
        sun: [0],
      });
      setInterviewTime({
        sun: [{ from: now, to: now }],
        mon: [{ from: now, to: now }],
        tue: [{ from: now, to: now }],
        wed: [{ from: now, to: now }],
        thru: [{ from: now, to: now }],
        fri: [{ from: now, to: now }],
        sat: [{ from: now, to: now }],
      });
    }
  };

  useEffect(() => {
    if (isSuccess) {
      setShowSuccess(true);
      setTimeout(() => navigate(-1), 500);
      dispatch(clearState());
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isError) {
      setIsShowError(true);
      setErrMessage(errorMessage);
    }
  }, [isError]);

  return (
    <>
      {isFetching && <PageLoader />}
      <ToastMessage
        show={showSuccess}
        setShow={() => setShowSuccess(false)}
        message={"Success"}
      />
      <ErrorToast
        show={isShowError}
        setShow={() => setIsShowError(false)}
        message={errMessage}
      />
      <div className="createInterviewSlotContainerOuter">
        <div className="pageHeader">
          <div className="backBtn">
            {/* <img src="../assets/icons/back-btn.svg" alt="" /> */}
            {/* Back to Page */}
            {/* onClick={() => navigate(-1)} */}
          </div>
          <div className="pageTogglers">
            <div className="pageToggler active">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7.91678 3.125C6.19089 3.125 4.79178 4.52411 4.79178 6.25C4.79178 7.97589 6.19089 9.375 7.91678 9.375C9.64267 9.375 11.0418 7.97589 11.0418 6.25C11.0418 4.52411 9.64267 3.125 7.91678 3.125ZM3.54178 6.25C3.54178 3.83375 5.50053 1.875 7.91678 1.875C10.333 1.875 12.2918 3.83375 12.2918 6.25C12.2918 8.66625 10.333 10.625 7.91678 10.625C5.50053 10.625 3.54178 8.66625 3.54178 6.25ZM12.7738 2.61165C12.9274 2.30254 13.3025 2.17649 13.6116 2.3301C15.0506 3.04525 16.0418 4.5313 16.0418 6.25C16.0418 7.9687 15.0506 9.45475 13.6116 10.1699C13.3025 10.3235 12.9274 10.1975 12.7738 9.88835C12.6201 9.57923 12.7462 9.20412 13.0553 9.0505C14.0858 8.5384 14.7918 7.47607 14.7918 6.25C14.7918 5.02393 14.0858 3.9616 13.0553 3.4495C12.7462 3.29588 12.6201 2.92077 12.7738 2.61165ZM7.91678 13.125C5.79794 13.125 3.88396 14.2802 2.65299 16.1284C2.49855 16.3603 2.41699 16.485 2.36864 16.5836C2.3336 16.6551 2.33612 16.6736 2.33676 16.6783C2.33679 16.6783 2.3377 16.6855 2.34228 16.7002C2.34771 16.7177 2.35637 16.7389 2.36831 16.7612C2.38025 16.7835 2.39311 16.8024 2.40461 16.8166C2.41253 16.8264 2.41785 16.8315 2.41954 16.833C2.42044 16.8335 2.42357 16.835 2.42994 16.8372C2.44529 16.8424 2.47754 16.8509 2.53957 16.8581C2.67638 16.874 2.86387 16.875 3.18541 16.875H12.6482C12.9697 16.875 13.1572 16.874 13.294 16.8581C13.356 16.8509 13.3883 16.8424 13.4036 16.8372C13.41 16.835 13.4131 16.8335 13.414 16.833C13.4157 16.8315 13.421 16.8264 13.429 16.8166C13.4405 16.8024 13.4533 16.7835 13.4653 16.7612C13.4772 16.7389 13.4859 16.7177 13.4913 16.7002C13.4959 16.6855 13.4968 16.6779 13.4968 16.6779C13.4974 16.6732 13.5 16.6551 13.4649 16.5836C13.4166 16.485 13.335 16.3603 13.1806 16.1284C11.9496 14.2802 10.0356 13.125 7.91678 13.125ZM1.61262 15.4355C3.03883 13.2941 5.31791 11.875 7.91678 11.875C10.5157 11.875 12.7947 13.2941 14.2209 15.4355C14.2266 15.444 14.2322 15.4524 14.2379 15.4609C14.3688 15.6574 14.4981 15.8515 14.5873 16.0333C14.6911 16.2451 14.761 16.4781 14.7445 16.754C14.7313 16.9735 14.6578 17.1821 14.5672 17.3512C14.4766 17.5204 14.3438 17.6972 14.1684 17.8298C13.9347 18.0066 13.6798 18.0717 13.4384 18.0997C13.2206 18.1251 12.9591 18.125 12.6787 18.125H3.15488C2.87446 18.125 2.61295 18.1251 2.39514 18.0997C2.15376 18.0717 1.89885 18.0066 1.66515 17.8298C1.4898 17.6972 1.35693 17.5204 1.26635 17.3512C1.17577 17.1821 1.10227 16.9735 1.0891 16.754C1.07253 16.4781 1.14246 16.2451 1.24628 16.0333C1.33544 15.8515 1.46479 15.6574 1.5957 15.4609L1.61262 15.4355ZM14.4416 12.9168C14.5966 12.6084 14.9722 12.484 15.2807 12.6389C16.6055 13.3044 17.7291 14.3659 18.5438 15.6784C18.5526 15.6925 18.5614 15.7067 18.5703 15.7209C18.6963 15.9227 18.8359 16.1464 18.882 16.4433C18.9344 16.7814 18.8429 17.1115 18.7006 17.3674C18.5582 17.6233 18.326 17.8751 18.0111 18.0089C17.7334 18.1269 17.432 18.126 17.1525 18.1251C17.1293 18.1251 17.1063 18.125 17.0834 18.125C16.7383 18.125 16.4584 17.8452 16.4584 17.5C16.4584 17.1548 16.7383 16.875 17.0834 16.875C17.2685 16.875 17.3723 16.8746 17.4501 16.8686C17.4849 16.8659 17.5039 16.8627 17.5136 16.8606C17.5182 16.8597 17.5206 16.859 17.5215 16.8587L17.5223 16.8584C17.5207 16.8591 17.5319 16.8544 17.5511 16.8359C17.5699 16.8176 17.5904 16.7916 17.6082 16.7597C17.6259 16.7279 17.6372 16.6967 17.6427 16.6711C17.648 16.6467 17.6467 16.6346 17.6467 16.6346C17.6456 16.6275 17.6439 16.6163 17.6264 16.5814C17.6012 16.5311 17.5624 16.4674 17.4818 16.3377C16.7781 15.204 15.8212 14.3093 14.7196 13.7559C14.4111 13.6009 14.2867 13.2253 14.4416 12.9168Z"
                  fill="#0061BF"
                />
              </svg>
              Set Mentor Call Slots
            </div>
          </div>
          <div>
            <button onClick={handleSave} className="success-btn">
              Save
            </button>
          </div>
        </div>
        <div className="createInterviewOuter">
          <div className="createInterviewSlotContainer">
            {/* <div className="form-grp">
              <label htmlFor="">Select Interviewer</label>
              <select name="" id="">
                <option value="" disabled selected>
                  Please Select
                </option>
                <option value="">1</option>
                <option value="">2</option>
              </select>
            </div> */}

            <div className="formGroup">
              {/* <br /> */}
              {/* <label className="form-label mt-5" htmlFor="">
                Invitees can schedule
              </label> */}
              {/* temp */}
              {/* <div className="flexbox">
                <select
                  onChange={(e) => setSelectedProgram(e.target.value)}
                  className="create-input"
                >
                  <option hidden>Select Program</option>
                  {summaryProgramList.length > 0 &&
                    summaryProgramList.map((item, i) => (
                      <option key={i} value={item.id}>
                        {item.programName}
                      </option>
                    ))}
                </select>
              </div>
              {localStorage.getItem("adminId") ===
                "3b19fa50-b1ff-4216-93bf-c786f8d8cd95" && (
                <div className="flexbox mt-10">
                  <select
                    className="create-input"
                    onChange={(e) => setSelectedInterviewer(e.target.value)}
                  >
                    <option hidden>Select Interviewer</option>
                    <option value="3b19fa50-b1ff-4216-93bf-c786f8d8cd95">
                      Gurji Kochar
                    </option>
                    <option value="378616ed-044f-46e5-bed7-0892a1ad63a5">
                      Vikas Singha
                    </option>
                    <option value="3161cb25-700d-42e1-a890-574f0cd4ed7e">
                      Shahrose Mukhtar Bhat
                    </option>
                    <option value="f5d42267-74ac-4181-b23b-8cad257e4ed7">
                      Dr. Aarti Sharma
                    </option>
                    <option value="661a12ee-73ab-4a9e-bbbf-052f94fd407b">
                      Vaibhav Achantani
                    </option>
                  </select>
                </div>
              )} */}
              <p className=" mt-15" htmlFor="">
                Date Range :
              </p>{" "}
              <div className="radio-group mt-10">
                <label className="create-label fix-radio">
                  <input
                    className="radio-btn"
                    type="radio"
                    name="interview"
                    checked={dateType === 1}
                    onChange={() => setDateType(1)}
                  />
                  <span className="radiomark"></span>
                  <div className="radioContent">
                    <p>Within a Date range from</p>
                    <input
                      type="date"
                      className="create-input"
                      onKeyDown={(e) => e.preventDefault()}
                      min={moment(new Date()).format("YYYY-MM-DD")}
                      onChange={(e) =>
                        setWithinDateRange({
                          from: e.target.value,
                          to: "",
                        })
                      }
                    />
                    <p>to</p>
                    <input
                      type="date"
                      className="create-input"
                      onKeyDown={(e) => e.preventDefault()}
                      value={
                        withinDateRange.to
                          ? moment(withinDateRange.to).format("YYYY-MM-DD")
                          : ""
                      }
                      min={
                        withinDateRange.from &&
                        moment(withinDateRange.from).format("YYYY-MM-DD")
                      }
                      onChange={(e) =>
                        setWithinDateRange((prev) => ({
                          ...prev,
                          to: e.target.value,
                        }))
                      }
                    />
                  </div>
                </label>
                {/* <label className="create-label">
                  <input
                    className="radio-btn"
                    type="radio"
                    name="interview"
                    checked={dateType === 2}
                    onChange={() => setDateType(2)}
                  />
                  <span className="radiomark"></span>
                  Indefinitely into the future
                </label> */}
              </div>
            </div>

            <div
              style={{ alignItems: "center", display: "flex", gap: "6px" }}
              className="success-tag"
            >
              {" "}
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7.00008 1.604C4.02004 1.604 1.60425 4.0198 1.60425 6.99984C1.60425 9.97987 4.02004 12.3957 7.00008 12.3957C9.98012 12.3957 12.3959 9.97987 12.3959 6.99984C12.3959 4.0198 9.98012 1.604 7.00008 1.604ZM0.729248 6.99984C0.729248 3.53655 3.5368 0.729004 7.00008 0.729004C10.4634 0.729004 13.2709 3.53655 13.2709 6.99984C13.2709 10.4631 10.4634 13.2707 7.00008 13.2707C3.5368 13.2707 0.729248 10.4631 0.729248 6.99984ZM7.00008 3.06234C7.24171 3.06234 7.43758 3.25821 7.43758 3.49984V6.72945L9.52907 7.77519C9.74519 7.88325 9.83278 8.14604 9.72473 8.36216C9.61667 8.57828 9.35387 8.66587 9.13776 8.55782L6.80443 7.39115C6.65621 7.31704 6.56258 7.16555 6.56258 6.99984V3.49984C6.56258 3.25821 6.75846 3.06234 7.00008 3.06234Z"
                  fill="#1C7C54"
                />
              </svg>
              Time slots will be of 30 min
            </div>
            <p className="heading">Set weekly hours</p>
            {/* <label style={{ color: "grey", fontSize: "14px", lineHeight: "0px" }}>( Unselected time slots will not be added )</label> */}
            {/* <p style={dateType !== 1 ? {color:"grey", fontSize:"14px", lineHeight:"0px"}: {display:"none"}}></p> */}
            {
              <div className="slotTableOuter">
                <table className="slotTable" cellPadding={0} cellSpacing={0}>
                  <tbody>
                    <tr>
                      <td>
                        <label className="checkbox-label">
                          <input
                            type="checkbox"
                            name="allCheck"
                            id="allCheck"
                            className="checkmark-btn"
                            onChange={() => handleCheckboxChange("sun")}
                            checked={selectedWeekDays.includes("sun")}
                          />
                          <span className="checkmarkspan"></span>
                        </label>
                      </td>
                      <td style={{ width: "10px" }}>SUN</td>
                      <td>
                        {selectedWeekDays.includes("sun") ? (
                          <div className="timeSlots">
                            {timeRangeCount?.sun?.map((j, i) => (
                              <div className="timeSlot">
                                <div className="">
                                  <TimePicker
                                    showSecond={false}
                                    defaultValue={now}
                                    value={interviewTime["sun"][i]?.from}
                                    className="xxx"
                                    onChange={(e) =>
                                      handleTimeFromChange(e, "sun", i)
                                    }
                                    format={format}
                                    use12Hours
                                    minuteStep={10}
                                  />
                                </div>
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M2.83325 8C2.83325 7.72386 3.05711 7.5 3.33325 7.5H12.6666C12.9427 7.5 13.1666 7.72386 13.1666 8C13.1666 8.27614 12.9427 8.5 12.6666 8.5H3.33325C3.05711 8.5 2.83325 8.27614 2.83325 8Z"
                                    fill="#404040"
                                  />
                                </svg>
                                <div className="">
                                  <TimePicker
                                    showSecond={false}
                                    //   defaultValue={now}
                                    value={interviewTime["sun"][i]?.to}
                                    className="xxx"
                                    onChange={(e) =>
                                      handleTimeToChange(e, "sun", i)
                                    }
                                    format={format}
                                    use12Hours
                                    minuteStep={10}
                                  />
                                </div>
                                <svg
                                  style={{ marginLeft: "10px" }}
                                  className="pointer"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  onClick={(e) =>
                                    handleTimeSlotRemove("sun", i)
                                  }
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M7.44638 0.833496H8.55362C8.90973 0.833489 9.20696 0.833483 9.44978 0.853323C9.70304 0.874015 9.94081 0.918755 10.1656 1.03332C10.5106 1.20909 10.7911 1.48955 10.9668 1.83451C11.0814 2.05936 11.1261 2.29713 11.1468 2.55038C11.1667 2.7932 11.1667 3.09043 11.1667 3.44653V3.50016H14C14.2761 3.50016 14.5 3.72402 14.5 4.00016C14.5 4.27631 14.2761 4.50016 14 4.50016H13.1667V11.4882C13.1667 12.0301 13.1667 12.4672 13.1378 12.8211C13.108 13.1856 13.0451 13.5057 12.8942 13.8018C12.6545 14.2722 12.272 14.6547 11.8016 14.8943C11.5055 15.0452 11.1854 15.1081 10.821 15.1379C10.467 15.1668 10.03 15.1668 9.48808 15.1668H6.51192C5.97003 15.1668 5.53296 15.1668 5.17902 15.1379C4.8146 15.1081 4.4945 15.0452 4.19836 14.8943C3.72795 14.6547 3.3455 14.2722 3.10582 13.8018C2.95492 13.5057 2.89202 13.1856 2.86224 12.8211C2.83332 12.4672 2.83333 12.0301 2.83333 11.4882L2.83333 4.50016H2C1.72386 4.50016 1.5 4.27631 1.5 4.00016C1.5 3.72402 1.72386 3.50016 2 3.50016H4.83333V3.44654C4.83333 3.09044 4.83332 2.79321 4.85316 2.55038C4.87385 2.29713 4.91859 2.05936 5.03315 1.83451C5.20892 1.48955 5.48939 1.20909 5.83435 1.03332C6.05919 0.918755 6.29696 0.874015 6.55022 0.853323C6.79304 0.833483 7.09027 0.833489 7.44638 0.833496ZM3.83333 4.50016V11.4668C3.83333 12.0351 3.83372 12.4313 3.85892 12.7397C3.88364 13.0423 3.92973 13.2161 3.99682 13.3478C4.14063 13.6301 4.3701 13.8595 4.65235 14.0033C4.78403 14.0704 4.95787 14.1165 5.26045 14.1412C5.56887 14.1664 5.96503 14.1668 6.53333 14.1668H9.46667C10.035 14.1668 10.4311 14.1664 10.7395 14.1412C11.0421 14.1165 11.216 14.0704 11.3477 14.0033C11.6299 13.8595 11.8594 13.6301 12.0032 13.3478C12.0703 13.2161 12.1164 13.0423 12.1411 12.7397C12.1663 12.4313 12.1667 12.0351 12.1667 11.4668V4.50016H3.83333ZM10.1667 3.50016H5.83333V3.46683C5.83333 3.08521 5.83372 2.82907 5.84984 2.63182C5.86548 2.4404 5.8934 2.34888 5.92416 2.2885C6.00406 2.1317 6.13154 2.00422 6.28834 1.92432C6.34872 1.89356 6.44024 1.86564 6.63165 1.85C6.8289 1.83389 7.08505 1.8335 7.46667 1.8335H8.53333C8.91495 1.8335 9.1711 1.83389 9.36835 1.85C9.55976 1.86564 9.65129 1.89356 9.71166 1.92432C9.86846 2.00422 9.99594 2.1317 10.0758 2.2885C10.1066 2.34888 10.1345 2.4404 10.1502 2.63182C10.1663 2.82907 10.1667 3.08521 10.1667 3.46683V3.50016ZM6.66667 7.16683C6.94281 7.16683 7.16667 7.39069 7.16667 7.66683V11.0002C7.16667 11.2763 6.94281 11.5002 6.66667 11.5002C6.39052 11.5002 6.16667 11.2763 6.16667 11.0002V7.66683C6.16667 7.39069 6.39052 7.16683 6.66667 7.16683ZM9.33333 7.16683C9.60948 7.16683 9.83333 7.39069 9.83333 7.66683V11.0002C9.83333 11.2763 9.60948 11.5002 9.33333 11.5002C9.05719 11.5002 8.83333 11.2763 8.83333 11.0002V7.66683C8.83333 7.39069 9.05719 7.16683 9.33333 7.16683Z"
                                    fill="#DF2935"
                                  />
                                </svg>
                              </div>
                            ))}
                          </div>
                        ) : (
                          "Unavailable"
                        )}
                      </td>
                      {selectedWeekDays.includes("sun") ? (
                        <td style={{ textAlign: "right" }}>
                          <svg
                            className="pointer"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            onClick={() => {
                              setTimeRangeCount({
                                ...timeRangeCount,
                                sun: [...timeRangeCount["sun"], 0],
                              });
                              setInterviewTime({
                                ...interviewTime,
                                sun: [
                                  ...interviewTime["sun"],
                                  { from: now, to: now },
                                ],
                              });
                            }}
                          >
                            <circle cx="12" cy="12" r="12" fill="#FAFAFA" />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M11.9999 6.8335C12.2761 6.8335 12.4999 7.05735 12.4999 7.3335V11.5002H16.6666C16.9427 11.5002 17.1666 11.724 17.1666 12.0002C17.1666 12.2763 16.9427 12.5002 16.6666 12.5002H12.4999V16.6668C12.4999 16.943 12.2761 17.1668 11.9999 17.1668C11.7238 17.1668 11.4999 16.943 11.4999 16.6668V12.5002H7.33325C7.05711 12.5002 6.83325 12.2763 6.83325 12.0002C6.83325 11.724 7.05711 11.5002 7.33325 11.5002H11.4999V7.3335C11.4999 7.05735 11.7238 6.8335 11.9999 6.8335Z"
                              fill="#404040"
                            />
                          </svg>
                        </td>
                      ) : (
                        <td></td>
                      )}
                    </tr>
                    <tr>
                      <td>
                        <label className="checkbox-label">
                          <input
                            type="checkbox"
                            name="allCheck"
                            id="allCheck"
                            className="checkmark-btn"
                            onChange={() => handleCheckboxChange("mon")}
                            checked={selectedWeekDays.includes("mon")}
                          />
                          <span className="checkmarkspan"></span>
                        </label>
                      </td>
                      <td> MON</td>
                      <td>
                        {selectedWeekDays.includes("mon") ? (
                          <div className="timeSlots">
                            {timeRangeCount?.mon?.map((j, i) => (
                              <div className="timeSlot">
                                <div className="">
                                  <TimePicker
                                    min="5:00 PM"
                                    showSecond={false}
                                    //   defaultValue={now}
                                    value={interviewTime["mon"][i]?.from}
                                    className="xxx"
                                    onChange={(e) =>
                                      handleTimeFromChange(e, "mon", i)
                                    }
                                    format={format}
                                    use12Hours
                                    minuteStep={10}
                                  />
                                </div>
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M2.83325 8C2.83325 7.72386 3.05711 7.5 3.33325 7.5H12.6666C12.9427 7.5 13.1666 7.72386 13.1666 8C13.1666 8.27614 12.9427 8.5 12.6666 8.5H3.33325C3.05711 8.5 2.83325 8.27614 2.83325 8Z"
                                    fill="#404040"
                                  />
                                </svg>
                                <div className="">
                                  <TimePicker
                                    showSecond={false}
                                    //   defaultValue={now}
                                    value={interviewTime["mon"][i]?.to}
                                    className="xxx"
                                    onChange={(e) =>
                                      handleTimeToChange(e, "mon", i)
                                    }
                                    format={format}
                                    use12Hours
                                    minuteStep={10}
                                  />
                                </div>
                                <svg
                                  style={{ marginLeft: "10px" }}
                                  className="pointer"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  onClick={(e) =>
                                    handleTimeSlotRemove("mon", i)
                                  }
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M7.44638 0.833496H8.55362C8.90973 0.833489 9.20696 0.833483 9.44978 0.853323C9.70304 0.874015 9.94081 0.918755 10.1656 1.03332C10.5106 1.20909 10.7911 1.48955 10.9668 1.83451C11.0814 2.05936 11.1261 2.29713 11.1468 2.55038C11.1667 2.7932 11.1667 3.09043 11.1667 3.44653V3.50016H14C14.2761 3.50016 14.5 3.72402 14.5 4.00016C14.5 4.27631 14.2761 4.50016 14 4.50016H13.1667V11.4882C13.1667 12.0301 13.1667 12.4672 13.1378 12.8211C13.108 13.1856 13.0451 13.5057 12.8942 13.8018C12.6545 14.2722 12.272 14.6547 11.8016 14.8943C11.5055 15.0452 11.1854 15.1081 10.821 15.1379C10.467 15.1668 10.03 15.1668 9.48808 15.1668H6.51192C5.97003 15.1668 5.53296 15.1668 5.17902 15.1379C4.8146 15.1081 4.4945 15.0452 4.19836 14.8943C3.72795 14.6547 3.3455 14.2722 3.10582 13.8018C2.95492 13.5057 2.89202 13.1856 2.86224 12.8211C2.83332 12.4672 2.83333 12.0301 2.83333 11.4882L2.83333 4.50016H2C1.72386 4.50016 1.5 4.27631 1.5 4.00016C1.5 3.72402 1.72386 3.50016 2 3.50016H4.83333V3.44654C4.83333 3.09044 4.83332 2.79321 4.85316 2.55038C4.87385 2.29713 4.91859 2.05936 5.03315 1.83451C5.20892 1.48955 5.48939 1.20909 5.83435 1.03332C6.05919 0.918755 6.29696 0.874015 6.55022 0.853323C6.79304 0.833483 7.09027 0.833489 7.44638 0.833496ZM3.83333 4.50016V11.4668C3.83333 12.0351 3.83372 12.4313 3.85892 12.7397C3.88364 13.0423 3.92973 13.2161 3.99682 13.3478C4.14063 13.6301 4.3701 13.8595 4.65235 14.0033C4.78403 14.0704 4.95787 14.1165 5.26045 14.1412C5.56887 14.1664 5.96503 14.1668 6.53333 14.1668H9.46667C10.035 14.1668 10.4311 14.1664 10.7395 14.1412C11.0421 14.1165 11.216 14.0704 11.3477 14.0033C11.6299 13.8595 11.8594 13.6301 12.0032 13.3478C12.0703 13.2161 12.1164 13.0423 12.1411 12.7397C12.1663 12.4313 12.1667 12.0351 12.1667 11.4668V4.50016H3.83333ZM10.1667 3.50016H5.83333V3.46683C5.83333 3.08521 5.83372 2.82907 5.84984 2.63182C5.86548 2.4404 5.8934 2.34888 5.92416 2.2885C6.00406 2.1317 6.13154 2.00422 6.28834 1.92432C6.34872 1.89356 6.44024 1.86564 6.63165 1.85C6.8289 1.83389 7.08505 1.8335 7.46667 1.8335H8.53333C8.91495 1.8335 9.1711 1.83389 9.36835 1.85C9.55976 1.86564 9.65129 1.89356 9.71166 1.92432C9.86846 2.00422 9.99594 2.1317 10.0758 2.2885C10.1066 2.34888 10.1345 2.4404 10.1502 2.63182C10.1663 2.82907 10.1667 3.08521 10.1667 3.46683V3.50016ZM6.66667 7.16683C6.94281 7.16683 7.16667 7.39069 7.16667 7.66683V11.0002C7.16667 11.2763 6.94281 11.5002 6.66667 11.5002C6.39052 11.5002 6.16667 11.2763 6.16667 11.0002V7.66683C6.16667 7.39069 6.39052 7.16683 6.66667 7.16683ZM9.33333 7.16683C9.60948 7.16683 9.83333 7.39069 9.83333 7.66683V11.0002C9.83333 11.2763 9.60948 11.5002 9.33333 11.5002C9.05719 11.5002 8.83333 11.2763 8.83333 11.0002V7.66683C8.83333 7.39069 9.05719 7.16683 9.33333 7.16683Z"
                                    fill="#DF2935"
                                  />
                                </svg>
                              </div>
                            ))}
                          </div>
                        ) : (
                          "Unavailable"
                        )}
                      </td>
                      {selectedWeekDays.includes("mon") ? (
                        <td style={{ textAlign: "right" }}>
                          <svg
                            className="pointer"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            onClick={() => {
                              setTimeRangeCount({
                                ...timeRangeCount,
                                mon: [...timeRangeCount["mon"], 0],
                              });
                              setInterviewTime({
                                ...interviewTime,
                                mon: [
                                  ...interviewTime["mon"],
                                  { from: now, to: now },
                                ],
                              });
                            }}
                          >
                            <circle cx="12" cy="12" r="12" fill="#FAFAFA" />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M11.9999 6.8335C12.2761 6.8335 12.4999 7.05735 12.4999 7.3335V11.5002H16.6666C16.9427 11.5002 17.1666 11.724 17.1666 12.0002C17.1666 12.2763 16.9427 12.5002 16.6666 12.5002H12.4999V16.6668C12.4999 16.943 12.2761 17.1668 11.9999 17.1668C11.7238 17.1668 11.4999 16.943 11.4999 16.6668V12.5002H7.33325C7.05711 12.5002 6.83325 12.2763 6.83325 12.0002C6.83325 11.724 7.05711 11.5002 7.33325 11.5002H11.4999V7.3335C11.4999 7.05735 11.7238 6.8335 11.9999 6.8335Z"
                              fill="#404040"
                            />
                          </svg>
                        </td>
                      ) : (
                        <td></td>
                      )}
                    </tr>
                    <tr>
                      <td>
                        <label className="checkbox-label">
                          <input
                            type="checkbox"
                            name="allCheck"
                            id="allCheck"
                            className="checkmark-btn"
                            onChange={() => handleCheckboxChange("tue")}
                            checked={selectedWeekDays.includes("tue")}
                          />
                          <span className="checkmarkspan"></span>
                        </label>
                      </td>
                      <td> TUE</td>
                      <td>
                        {selectedWeekDays.includes("tue") ? (
                          <div className="timeSlots">
                            {timeRangeCount?.tue?.map((j, i) => (
                              <div className="timeSlot">
                                <div className="">
                                  <TimePicker
                                    showSecond={false}
                                    value={interviewTime["tue"][i]?.from}
                                    className="xxx"
                                    onChange={(e) =>
                                      handleTimeFromChange(e, "tue", i)
                                    }
                                    format={format}
                                    use12Hours
                                    minuteStep={10}
                                  />
                                </div>
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M2.83325 8C2.83325 7.72386 3.05711 7.5 3.33325 7.5H12.6666C12.9427 7.5 13.1666 7.72386 13.1666 8C13.1666 8.27614 12.9427 8.5 12.6666 8.5H3.33325C3.05711 8.5 2.83325 8.27614 2.83325 8Z"
                                    fill="#404040"
                                  />
                                </svg>
                                <div className="">
                                  <TimePicker
                                    showSecond={false}
                                    value={interviewTime["tue"][i]?.to}
                                    className="xxx"
                                    onChange={(e) =>
                                      handleTimeToChange(e, "tue", i)
                                    }
                                    format={format}
                                    use12Hours
                                    minuteStep={10}
                                  />
                                </div>
                                <svg
                                  style={{ marginLeft: "10px" }}
                                  className="pointer"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  onClick={(e) =>
                                    handleTimeSlotRemove("tue", i)
                                  }
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M7.44638 0.833496H8.55362C8.90973 0.833489 9.20696 0.833483 9.44978 0.853323C9.70304 0.874015 9.94081 0.918755 10.1656 1.03332C10.5106 1.20909 10.7911 1.48955 10.9668 1.83451C11.0814 2.05936 11.1261 2.29713 11.1468 2.55038C11.1667 2.7932 11.1667 3.09043 11.1667 3.44653V3.50016H14C14.2761 3.50016 14.5 3.72402 14.5 4.00016C14.5 4.27631 14.2761 4.50016 14 4.50016H13.1667V11.4882C13.1667 12.0301 13.1667 12.4672 13.1378 12.8211C13.108 13.1856 13.0451 13.5057 12.8942 13.8018C12.6545 14.2722 12.272 14.6547 11.8016 14.8943C11.5055 15.0452 11.1854 15.1081 10.821 15.1379C10.467 15.1668 10.03 15.1668 9.48808 15.1668H6.51192C5.97003 15.1668 5.53296 15.1668 5.17902 15.1379C4.8146 15.1081 4.4945 15.0452 4.19836 14.8943C3.72795 14.6547 3.3455 14.2722 3.10582 13.8018C2.95492 13.5057 2.89202 13.1856 2.86224 12.8211C2.83332 12.4672 2.83333 12.0301 2.83333 11.4882L2.83333 4.50016H2C1.72386 4.50016 1.5 4.27631 1.5 4.00016C1.5 3.72402 1.72386 3.50016 2 3.50016H4.83333V3.44654C4.83333 3.09044 4.83332 2.79321 4.85316 2.55038C4.87385 2.29713 4.91859 2.05936 5.03315 1.83451C5.20892 1.48955 5.48939 1.20909 5.83435 1.03332C6.05919 0.918755 6.29696 0.874015 6.55022 0.853323C6.79304 0.833483 7.09027 0.833489 7.44638 0.833496ZM3.83333 4.50016V11.4668C3.83333 12.0351 3.83372 12.4313 3.85892 12.7397C3.88364 13.0423 3.92973 13.2161 3.99682 13.3478C4.14063 13.6301 4.3701 13.8595 4.65235 14.0033C4.78403 14.0704 4.95787 14.1165 5.26045 14.1412C5.56887 14.1664 5.96503 14.1668 6.53333 14.1668H9.46667C10.035 14.1668 10.4311 14.1664 10.7395 14.1412C11.0421 14.1165 11.216 14.0704 11.3477 14.0033C11.6299 13.8595 11.8594 13.6301 12.0032 13.3478C12.0703 13.2161 12.1164 13.0423 12.1411 12.7397C12.1663 12.4313 12.1667 12.0351 12.1667 11.4668V4.50016H3.83333ZM10.1667 3.50016H5.83333V3.46683C5.83333 3.08521 5.83372 2.82907 5.84984 2.63182C5.86548 2.4404 5.8934 2.34888 5.92416 2.2885C6.00406 2.1317 6.13154 2.00422 6.28834 1.92432C6.34872 1.89356 6.44024 1.86564 6.63165 1.85C6.8289 1.83389 7.08505 1.8335 7.46667 1.8335H8.53333C8.91495 1.8335 9.1711 1.83389 9.36835 1.85C9.55976 1.86564 9.65129 1.89356 9.71166 1.92432C9.86846 2.00422 9.99594 2.1317 10.0758 2.2885C10.1066 2.34888 10.1345 2.4404 10.1502 2.63182C10.1663 2.82907 10.1667 3.08521 10.1667 3.46683V3.50016ZM6.66667 7.16683C6.94281 7.16683 7.16667 7.39069 7.16667 7.66683V11.0002C7.16667 11.2763 6.94281 11.5002 6.66667 11.5002C6.39052 11.5002 6.16667 11.2763 6.16667 11.0002V7.66683C6.16667 7.39069 6.39052 7.16683 6.66667 7.16683ZM9.33333 7.16683C9.60948 7.16683 9.83333 7.39069 9.83333 7.66683V11.0002C9.83333 11.2763 9.60948 11.5002 9.33333 11.5002C9.05719 11.5002 8.83333 11.2763 8.83333 11.0002V7.66683C8.83333 7.39069 9.05719 7.16683 9.33333 7.16683Z"
                                    fill="#DF2935"
                                  />
                                </svg>
                              </div>
                            ))}
                          </div>
                        ) : (
                          "Unavailable"
                        )}
                      </td>
                      {selectedWeekDays.includes("tue") ? (
                        <td style={{ textAlign: "right" }}>
                          <svg
                            className="pointer"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            onClick={() => {
                              setTimeRangeCount({
                                ...timeRangeCount,
                                tue: [...timeRangeCount["tue"], 0],
                              });
                              setInterviewTime({
                                ...interviewTime,
                                tue: [
                                  ...interviewTime["tue"],
                                  { from: now, to: now },
                                ],
                              });
                            }}
                          >
                            <circle cx="12" cy="12" r="12" fill="#FAFAFA" />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M11.9999 6.8335C12.2761 6.8335 12.4999 7.05735 12.4999 7.3335V11.5002H16.6666C16.9427 11.5002 17.1666 11.724 17.1666 12.0002C17.1666 12.2763 16.9427 12.5002 16.6666 12.5002H12.4999V16.6668C12.4999 16.943 12.2761 17.1668 11.9999 17.1668C11.7238 17.1668 11.4999 16.943 11.4999 16.6668V12.5002H7.33325C7.05711 12.5002 6.83325 12.2763 6.83325 12.0002C6.83325 11.724 7.05711 11.5002 7.33325 11.5002H11.4999V7.3335C11.4999 7.05735 11.7238 6.8335 11.9999 6.8335Z"
                              fill="#404040"
                            />
                          </svg>
                        </td>
                      ) : (
                        <td></td>
                      )}
                    </tr>
                    <tr>
                      <td>
                        <label className="checkbox-label">
                          <input
                            type="checkbox"
                            name="allCheck"
                            id="allCheck"
                            className="checkmark-btn"
                            onChange={() => handleCheckboxChange("wed")}
                            checked={selectedWeekDays.includes("wed")}
                          />
                          <span className="checkmarkspan"></span>
                        </label>
                      </td>
                      <td> WED</td>
                      <td>
                        {selectedWeekDays.includes("wed") ? (
                          <div className="timeSlots">
                            {timeRangeCount?.wed.map((j, i) => (
                              <div className="timeSlot">
                                <div className="">
                                  <TimePicker
                                    showSecond={false}
                                    value={interviewTime["wed"][i]?.from}
                                    className="xxx"
                                    onChange={(e) =>
                                      handleTimeFromChange(e, "wed", i)
                                    }
                                    format={format}
                                    use12Hours
                                    minuteStep={10}
                                  />
                                </div>
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M2.83325 8C2.83325 7.72386 3.05711 7.5 3.33325 7.5H12.6666C12.9427 7.5 13.1666 7.72386 13.1666 8C13.1666 8.27614 12.9427 8.5 12.6666 8.5H3.33325C3.05711 8.5 2.83325 8.27614 2.83325 8Z"
                                    fill="#404040"
                                  />
                                </svg>
                                <div className="">
                                  <TimePicker
                                    showSecond={false}
                                    value={interviewTime["wed"][i]?.to}
                                    className="xxx"
                                    onChange={(e) =>
                                      handleTimeToChange(e, "wed", i)
                                    }
                                    format={format}
                                    use12Hours
                                    minuteStep={10}
                                  />
                                </div>
                                <svg
                                  style={{ marginLeft: "10px" }}
                                  className="pointer"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  onClick={(e) =>
                                    handleTimeSlotRemove("wed", i)
                                  }
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M7.44638 0.833496H8.55362C8.90973 0.833489 9.20696 0.833483 9.44978 0.853323C9.70304 0.874015 9.94081 0.918755 10.1656 1.03332C10.5106 1.20909 10.7911 1.48955 10.9668 1.83451C11.0814 2.05936 11.1261 2.29713 11.1468 2.55038C11.1667 2.7932 11.1667 3.09043 11.1667 3.44653V3.50016H14C14.2761 3.50016 14.5 3.72402 14.5 4.00016C14.5 4.27631 14.2761 4.50016 14 4.50016H13.1667V11.4882C13.1667 12.0301 13.1667 12.4672 13.1378 12.8211C13.108 13.1856 13.0451 13.5057 12.8942 13.8018C12.6545 14.2722 12.272 14.6547 11.8016 14.8943C11.5055 15.0452 11.1854 15.1081 10.821 15.1379C10.467 15.1668 10.03 15.1668 9.48808 15.1668H6.51192C5.97003 15.1668 5.53296 15.1668 5.17902 15.1379C4.8146 15.1081 4.4945 15.0452 4.19836 14.8943C3.72795 14.6547 3.3455 14.2722 3.10582 13.8018C2.95492 13.5057 2.89202 13.1856 2.86224 12.8211C2.83332 12.4672 2.83333 12.0301 2.83333 11.4882L2.83333 4.50016H2C1.72386 4.50016 1.5 4.27631 1.5 4.00016C1.5 3.72402 1.72386 3.50016 2 3.50016H4.83333V3.44654C4.83333 3.09044 4.83332 2.79321 4.85316 2.55038C4.87385 2.29713 4.91859 2.05936 5.03315 1.83451C5.20892 1.48955 5.48939 1.20909 5.83435 1.03332C6.05919 0.918755 6.29696 0.874015 6.55022 0.853323C6.79304 0.833483 7.09027 0.833489 7.44638 0.833496ZM3.83333 4.50016V11.4668C3.83333 12.0351 3.83372 12.4313 3.85892 12.7397C3.88364 13.0423 3.92973 13.2161 3.99682 13.3478C4.14063 13.6301 4.3701 13.8595 4.65235 14.0033C4.78403 14.0704 4.95787 14.1165 5.26045 14.1412C5.56887 14.1664 5.96503 14.1668 6.53333 14.1668H9.46667C10.035 14.1668 10.4311 14.1664 10.7395 14.1412C11.0421 14.1165 11.216 14.0704 11.3477 14.0033C11.6299 13.8595 11.8594 13.6301 12.0032 13.3478C12.0703 13.2161 12.1164 13.0423 12.1411 12.7397C12.1663 12.4313 12.1667 12.0351 12.1667 11.4668V4.50016H3.83333ZM10.1667 3.50016H5.83333V3.46683C5.83333 3.08521 5.83372 2.82907 5.84984 2.63182C5.86548 2.4404 5.8934 2.34888 5.92416 2.2885C6.00406 2.1317 6.13154 2.00422 6.28834 1.92432C6.34872 1.89356 6.44024 1.86564 6.63165 1.85C6.8289 1.83389 7.08505 1.8335 7.46667 1.8335H8.53333C8.91495 1.8335 9.1711 1.83389 9.36835 1.85C9.55976 1.86564 9.65129 1.89356 9.71166 1.92432C9.86846 2.00422 9.99594 2.1317 10.0758 2.2885C10.1066 2.34888 10.1345 2.4404 10.1502 2.63182C10.1663 2.82907 10.1667 3.08521 10.1667 3.46683V3.50016ZM6.66667 7.16683C6.94281 7.16683 7.16667 7.39069 7.16667 7.66683V11.0002C7.16667 11.2763 6.94281 11.5002 6.66667 11.5002C6.39052 11.5002 6.16667 11.2763 6.16667 11.0002V7.66683C6.16667 7.39069 6.39052 7.16683 6.66667 7.16683ZM9.33333 7.16683C9.60948 7.16683 9.83333 7.39069 9.83333 7.66683V11.0002C9.83333 11.2763 9.60948 11.5002 9.33333 11.5002C9.05719 11.5002 8.83333 11.2763 8.83333 11.0002V7.66683C8.83333 7.39069 9.05719 7.16683 9.33333 7.16683Z"
                                    fill="#DF2935"
                                  />
                                </svg>
                              </div>
                            ))}
                          </div>
                        ) : (
                          "Unavailable"
                        )}
                      </td>
                      {selectedWeekDays.includes("wed") ? (
                        <td style={{ textAlign: "right" }}>
                          <svg
                            className="pointer"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            onClick={() => {
                              setTimeRangeCount({
                                ...timeRangeCount,
                                wed: [...timeRangeCount["wed"], 0],
                              });
                              setInterviewTime({
                                ...interviewTime,
                                wed: [
                                  ...interviewTime["wed"],
                                  { from: now, to: now },
                                ],
                              });
                            }}
                          >
                            <circle cx="12" cy="12" r="12" fill="#FAFAFA" />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M11.9999 6.8335C12.2761 6.8335 12.4999 7.05735 12.4999 7.3335V11.5002H16.6666C16.9427 11.5002 17.1666 11.724 17.1666 12.0002C17.1666 12.2763 16.9427 12.5002 16.6666 12.5002H12.4999V16.6668C12.4999 16.943 12.2761 17.1668 11.9999 17.1668C11.7238 17.1668 11.4999 16.943 11.4999 16.6668V12.5002H7.33325C7.05711 12.5002 6.83325 12.2763 6.83325 12.0002C6.83325 11.724 7.05711 11.5002 7.33325 11.5002H11.4999V7.3335C11.4999 7.05735 11.7238 6.8335 11.9999 6.8335Z"
                              fill="#404040"
                            />
                          </svg>
                        </td>
                      ) : (
                        <td></td>
                      )}
                    </tr>
                    <tr>
                      <td>
                        <label className="checkbox-label">
                          <input
                            type="checkbox"
                            name="allCheck"
                            id="allCheck"
                            className="checkmark-btn"
                            onChange={() => handleCheckboxChange("thru")}
                            checked={selectedWeekDays.includes("thru")}
                          />
                          <span className="checkmarkspan"></span>
                        </label>
                      </td>
                      <td> THU</td>
                      <td>
                        {selectedWeekDays.includes("thru") ? (
                          <div className="timeSlots">
                            {timeRangeCount?.thru?.map((j, i) => (
                              <div className="timeSlot">
                                <div className="">
                                  <TimePicker
                                    showSecond={false}
                                    value={interviewTime["thru"][i]?.from}
                                    className="xxx"
                                    onChange={(e) =>
                                      handleTimeFromChange(e, "thru", i)
                                    }
                                    format={format}
                                    use12Hours
                                    minuteStep={10}
                                  />
                                </div>
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M2.83325 8C2.83325 7.72386 3.05711 7.5 3.33325 7.5H12.6666C12.9427 7.5 13.1666 7.72386 13.1666 8C13.1666 8.27614 12.9427 8.5 12.6666 8.5H3.33325C3.05711 8.5 2.83325 8.27614 2.83325 8Z"
                                    fill="#404040"
                                  />
                                </svg>
                                <div className="">
                                  <TimePicker
                                    showSecond={false}
                                    value={interviewTime["thru"][i]?.to}
                                    className="xxx"
                                    onChange={(e) =>
                                      handleTimeToChange(e, "thru", i)
                                    }
                                    format={format}
                                    use12Hours
                                    minuteStep={10}
                                  />
                                </div>
                                <svg
                                  style={{ marginLeft: "10px" }}
                                  className="pointer"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  onClick={(e) =>
                                    handleTimeSlotRemove("thru", i)
                                  }
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M7.44638 0.833496H8.55362C8.90973 0.833489 9.20696 0.833483 9.44978 0.853323C9.70304 0.874015 9.94081 0.918755 10.1656 1.03332C10.5106 1.20909 10.7911 1.48955 10.9668 1.83451C11.0814 2.05936 11.1261 2.29713 11.1468 2.55038C11.1667 2.7932 11.1667 3.09043 11.1667 3.44653V3.50016H14C14.2761 3.50016 14.5 3.72402 14.5 4.00016C14.5 4.27631 14.2761 4.50016 14 4.50016H13.1667V11.4882C13.1667 12.0301 13.1667 12.4672 13.1378 12.8211C13.108 13.1856 13.0451 13.5057 12.8942 13.8018C12.6545 14.2722 12.272 14.6547 11.8016 14.8943C11.5055 15.0452 11.1854 15.1081 10.821 15.1379C10.467 15.1668 10.03 15.1668 9.48808 15.1668H6.51192C5.97003 15.1668 5.53296 15.1668 5.17902 15.1379C4.8146 15.1081 4.4945 15.0452 4.19836 14.8943C3.72795 14.6547 3.3455 14.2722 3.10582 13.8018C2.95492 13.5057 2.89202 13.1856 2.86224 12.8211C2.83332 12.4672 2.83333 12.0301 2.83333 11.4882L2.83333 4.50016H2C1.72386 4.50016 1.5 4.27631 1.5 4.00016C1.5 3.72402 1.72386 3.50016 2 3.50016H4.83333V3.44654C4.83333 3.09044 4.83332 2.79321 4.85316 2.55038C4.87385 2.29713 4.91859 2.05936 5.03315 1.83451C5.20892 1.48955 5.48939 1.20909 5.83435 1.03332C6.05919 0.918755 6.29696 0.874015 6.55022 0.853323C6.79304 0.833483 7.09027 0.833489 7.44638 0.833496ZM3.83333 4.50016V11.4668C3.83333 12.0351 3.83372 12.4313 3.85892 12.7397C3.88364 13.0423 3.92973 13.2161 3.99682 13.3478C4.14063 13.6301 4.3701 13.8595 4.65235 14.0033C4.78403 14.0704 4.95787 14.1165 5.26045 14.1412C5.56887 14.1664 5.96503 14.1668 6.53333 14.1668H9.46667C10.035 14.1668 10.4311 14.1664 10.7395 14.1412C11.0421 14.1165 11.216 14.0704 11.3477 14.0033C11.6299 13.8595 11.8594 13.6301 12.0032 13.3478C12.0703 13.2161 12.1164 13.0423 12.1411 12.7397C12.1663 12.4313 12.1667 12.0351 12.1667 11.4668V4.50016H3.83333ZM10.1667 3.50016H5.83333V3.46683C5.83333 3.08521 5.83372 2.82907 5.84984 2.63182C5.86548 2.4404 5.8934 2.34888 5.92416 2.2885C6.00406 2.1317 6.13154 2.00422 6.28834 1.92432C6.34872 1.89356 6.44024 1.86564 6.63165 1.85C6.8289 1.83389 7.08505 1.8335 7.46667 1.8335H8.53333C8.91495 1.8335 9.1711 1.83389 9.36835 1.85C9.55976 1.86564 9.65129 1.89356 9.71166 1.92432C9.86846 2.00422 9.99594 2.1317 10.0758 2.2885C10.1066 2.34888 10.1345 2.4404 10.1502 2.63182C10.1663 2.82907 10.1667 3.08521 10.1667 3.46683V3.50016ZM6.66667 7.16683C6.94281 7.16683 7.16667 7.39069 7.16667 7.66683V11.0002C7.16667 11.2763 6.94281 11.5002 6.66667 11.5002C6.39052 11.5002 6.16667 11.2763 6.16667 11.0002V7.66683C6.16667 7.39069 6.39052 7.16683 6.66667 7.16683ZM9.33333 7.16683C9.60948 7.16683 9.83333 7.39069 9.83333 7.66683V11.0002C9.83333 11.2763 9.60948 11.5002 9.33333 11.5002C9.05719 11.5002 8.83333 11.2763 8.83333 11.0002V7.66683C8.83333 7.39069 9.05719 7.16683 9.33333 7.16683Z"
                                    fill="#DF2935"
                                  />
                                </svg>
                              </div>
                            ))}
                          </div>
                        ) : (
                          "Unavailable"
                        )}
                      </td>
                      {selectedWeekDays.includes("thru") ? (
                        <td style={{ textAlign: "right" }}>
                          <svg
                            className="pointer"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            onClick={() => {
                              setTimeRangeCount({
                                ...timeRangeCount,
                                thru: [...timeRangeCount["thru"], 0],
                              });
                              setInterviewTime({
                                ...interviewTime,
                                thru: [
                                  ...interviewTime["thru"],
                                  { from: now, to: now },
                                ],
                              });
                            }}
                          >
                            <circle cx="12" cy="12" r="12" fill="#FAFAFA" />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M11.9999 6.8335C12.2761 6.8335 12.4999 7.05735 12.4999 7.3335V11.5002H16.6666C16.9427 11.5002 17.1666 11.724 17.1666 12.0002C17.1666 12.2763 16.9427 12.5002 16.6666 12.5002H12.4999V16.6668C12.4999 16.943 12.2761 17.1668 11.9999 17.1668C11.7238 17.1668 11.4999 16.943 11.4999 16.6668V12.5002H7.33325C7.05711 12.5002 6.83325 12.2763 6.83325 12.0002C6.83325 11.724 7.05711 11.5002 7.33325 11.5002H11.4999V7.3335C11.4999 7.05735 11.7238 6.8335 11.9999 6.8335Z"
                              fill="#404040"
                            />
                          </svg>
                        </td>
                      ) : (
                        <td></td>
                      )}
                    </tr>
                    <tr>
                      <td>
                        <label className="checkbox-label">
                          <input
                            type="checkbox"
                            name="allCheck"
                            id="allCheck"
                            className="checkmark-btn"
                            onChange={() => handleCheckboxChange("fri")}
                            checked={selectedWeekDays.includes("fri")}
                          />
                          <span className="checkmarkspan"></span>
                        </label>
                      </td>
                      <td> FRI</td>
                      <td>
                        {selectedWeekDays.includes("fri") ? (
                          <div className="timeSlots">
                            {timeRangeCount?.fri?.map((j, i) => (
                              <div className="timeSlot">
                                <div className="">
                                  <TimePicker
                                    showSecond={false}
                                    value={interviewTime["fri"][i]?.from}
                                    className="xxx"
                                    onChange={(e) =>
                                      handleTimeFromChange(e, "fri", i)
                                    }
                                    format={format}
                                    use12Hours
                                    minuteStep={10}
                                  />
                                </div>
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M2.83325 8C2.83325 7.72386 3.05711 7.5 3.33325 7.5H12.6666C12.9427 7.5 13.1666 7.72386 13.1666 8C13.1666 8.27614 12.9427 8.5 12.6666 8.5H3.33325C3.05711 8.5 2.83325 8.27614 2.83325 8Z"
                                    fill="#404040"
                                  />
                                </svg>
                                <div className="">
                                  <TimePicker
                                    showSecond={false}
                                    value={interviewTime["fri"][i]?.to}
                                    className="xxx"
                                    onChange={(e) =>
                                      handleTimeToChange(e, "fri", i)
                                    }
                                    format={format}
                                    use12Hours
                                    minuteStep={10}
                                  />
                                </div>
                                <svg
                                  style={{ marginLeft: "10px" }}
                                  className="pointer"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  onClick={(e) =>
                                    handleTimeSlotRemove("fri", i)
                                  }
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M7.44638 0.833496H8.55362C8.90973 0.833489 9.20696 0.833483 9.44978 0.853323C9.70304 0.874015 9.94081 0.918755 10.1656 1.03332C10.5106 1.20909 10.7911 1.48955 10.9668 1.83451C11.0814 2.05936 11.1261 2.29713 11.1468 2.55038C11.1667 2.7932 11.1667 3.09043 11.1667 3.44653V3.50016H14C14.2761 3.50016 14.5 3.72402 14.5 4.00016C14.5 4.27631 14.2761 4.50016 14 4.50016H13.1667V11.4882C13.1667 12.0301 13.1667 12.4672 13.1378 12.8211C13.108 13.1856 13.0451 13.5057 12.8942 13.8018C12.6545 14.2722 12.272 14.6547 11.8016 14.8943C11.5055 15.0452 11.1854 15.1081 10.821 15.1379C10.467 15.1668 10.03 15.1668 9.48808 15.1668H6.51192C5.97003 15.1668 5.53296 15.1668 5.17902 15.1379C4.8146 15.1081 4.4945 15.0452 4.19836 14.8943C3.72795 14.6547 3.3455 14.2722 3.10582 13.8018C2.95492 13.5057 2.89202 13.1856 2.86224 12.8211C2.83332 12.4672 2.83333 12.0301 2.83333 11.4882L2.83333 4.50016H2C1.72386 4.50016 1.5 4.27631 1.5 4.00016C1.5 3.72402 1.72386 3.50016 2 3.50016H4.83333V3.44654C4.83333 3.09044 4.83332 2.79321 4.85316 2.55038C4.87385 2.29713 4.91859 2.05936 5.03315 1.83451C5.20892 1.48955 5.48939 1.20909 5.83435 1.03332C6.05919 0.918755 6.29696 0.874015 6.55022 0.853323C6.79304 0.833483 7.09027 0.833489 7.44638 0.833496ZM3.83333 4.50016V11.4668C3.83333 12.0351 3.83372 12.4313 3.85892 12.7397C3.88364 13.0423 3.92973 13.2161 3.99682 13.3478C4.14063 13.6301 4.3701 13.8595 4.65235 14.0033C4.78403 14.0704 4.95787 14.1165 5.26045 14.1412C5.56887 14.1664 5.96503 14.1668 6.53333 14.1668H9.46667C10.035 14.1668 10.4311 14.1664 10.7395 14.1412C11.0421 14.1165 11.216 14.0704 11.3477 14.0033C11.6299 13.8595 11.8594 13.6301 12.0032 13.3478C12.0703 13.2161 12.1164 13.0423 12.1411 12.7397C12.1663 12.4313 12.1667 12.0351 12.1667 11.4668V4.50016H3.83333ZM10.1667 3.50016H5.83333V3.46683C5.83333 3.08521 5.83372 2.82907 5.84984 2.63182C5.86548 2.4404 5.8934 2.34888 5.92416 2.2885C6.00406 2.1317 6.13154 2.00422 6.28834 1.92432C6.34872 1.89356 6.44024 1.86564 6.63165 1.85C6.8289 1.83389 7.08505 1.8335 7.46667 1.8335H8.53333C8.91495 1.8335 9.1711 1.83389 9.36835 1.85C9.55976 1.86564 9.65129 1.89356 9.71166 1.92432C9.86846 2.00422 9.99594 2.1317 10.0758 2.2885C10.1066 2.34888 10.1345 2.4404 10.1502 2.63182C10.1663 2.82907 10.1667 3.08521 10.1667 3.46683V3.50016ZM6.66667 7.16683C6.94281 7.16683 7.16667 7.39069 7.16667 7.66683V11.0002C7.16667 11.2763 6.94281 11.5002 6.66667 11.5002C6.39052 11.5002 6.16667 11.2763 6.16667 11.0002V7.66683C6.16667 7.39069 6.39052 7.16683 6.66667 7.16683ZM9.33333 7.16683C9.60948 7.16683 9.83333 7.39069 9.83333 7.66683V11.0002C9.83333 11.2763 9.60948 11.5002 9.33333 11.5002C9.05719 11.5002 8.83333 11.2763 8.83333 11.0002V7.66683C8.83333 7.39069 9.05719 7.16683 9.33333 7.16683Z"
                                    fill="#DF2935"
                                  />
                                </svg>
                              </div>
                            ))}
                          </div>
                        ) : (
                          "Unavailable"
                        )}
                      </td>
                      {selectedWeekDays.includes("fri") ? (
                        <td style={{ textAlign: "right" }}>
                          <svg
                            className="pointer"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            onClick={() => {
                              setTimeRangeCount({
                                ...timeRangeCount,
                                fri: [...timeRangeCount["fri"], 0],
                              });
                              setInterviewTime({
                                ...interviewTime,
                                fri: [
                                  ...interviewTime["fri"],
                                  { from: now, to: now },
                                ],
                              });
                            }}
                          >
                            <circle cx="12" cy="12" r="12" fill="#FAFAFA" />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M11.9999 6.8335C12.2761 6.8335 12.4999 7.05735 12.4999 7.3335V11.5002H16.6666C16.9427 11.5002 17.1666 11.724 17.1666 12.0002C17.1666 12.2763 16.9427 12.5002 16.6666 12.5002H12.4999V16.6668C12.4999 16.943 12.2761 17.1668 11.9999 17.1668C11.7238 17.1668 11.4999 16.943 11.4999 16.6668V12.5002H7.33325C7.05711 12.5002 6.83325 12.2763 6.83325 12.0002C6.83325 11.724 7.05711 11.5002 7.33325 11.5002H11.4999V7.3335C11.4999 7.05735 11.7238 6.8335 11.9999 6.8335Z"
                              fill="#404040"
                            />
                          </svg>
                        </td>
                      ) : (
                        <td></td>
                      )}
                    </tr>
                    <tr>
                      <td>
                        <label className="checkbox-label">
                          <input
                            type="checkbox"
                            name="allCheck"
                            id="allCheck"
                            className="checkmark-btn"
                            onChange={() => handleCheckboxChange("sat")}
                            checked={selectedWeekDays.includes("sat")}
                          />
                          <span className="checkmarkspan"></span>
                        </label>
                      </td>
                      <td> SAT</td>
                      <td>
                        {selectedWeekDays.includes("sat") ? (
                          <div className="timeSlots">
                            {timeRangeCount?.sat?.map((j, i) => (
                              <div className="timeSlot">
                                <div className="">
                                  <TimePicker
                                    showSecond={false}
                                    value={interviewTime["sat"][i]?.from}
                                    className="xxx"
                                    onChange={(e) =>
                                      handleTimeFromChange(e, "sat", i)
                                    }
                                    format={format}
                                    use12Hours
                                    minuteStep={10}
                                  />
                                </div>
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M2.83325 8C2.83325 7.72386 3.05711 7.5 3.33325 7.5H12.6666C12.9427 7.5 13.1666 7.72386 13.1666 8C13.1666 8.27614 12.9427 8.5 12.6666 8.5H3.33325C3.05711 8.5 2.83325 8.27614 2.83325 8Z"
                                    fill="#404040"
                                  />
                                </svg>
                                <div className="">
                                  <TimePicker
                                    showSecond={false}
                                    value={interviewTime["sat"][i]?.to}
                                    className="xxx"
                                    onChange={(e) =>
                                      handleTimeToChange(e, "sat", i)
                                    }
                                    format={format}
                                    use12Hours
                                    minuteStep={10}
                                  />
                                </div>
                                <svg
                                  style={{ marginLeft: "10px" }}
                                  className="pointer"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  onClick={(e) =>
                                    handleTimeSlotRemove("sat", i)
                                  }
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M7.44638 0.833496H8.55362C8.90973 0.833489 9.20696 0.833483 9.44978 0.853323C9.70304 0.874015 9.94081 0.918755 10.1656 1.03332C10.5106 1.20909 10.7911 1.48955 10.9668 1.83451C11.0814 2.05936 11.1261 2.29713 11.1468 2.55038C11.1667 2.7932 11.1667 3.09043 11.1667 3.44653V3.50016H14C14.2761 3.50016 14.5 3.72402 14.5 4.00016C14.5 4.27631 14.2761 4.50016 14 4.50016H13.1667V11.4882C13.1667 12.0301 13.1667 12.4672 13.1378 12.8211C13.108 13.1856 13.0451 13.5057 12.8942 13.8018C12.6545 14.2722 12.272 14.6547 11.8016 14.8943C11.5055 15.0452 11.1854 15.1081 10.821 15.1379C10.467 15.1668 10.03 15.1668 9.48808 15.1668H6.51192C5.97003 15.1668 5.53296 15.1668 5.17902 15.1379C4.8146 15.1081 4.4945 15.0452 4.19836 14.8943C3.72795 14.6547 3.3455 14.2722 3.10582 13.8018C2.95492 13.5057 2.89202 13.1856 2.86224 12.8211C2.83332 12.4672 2.83333 12.0301 2.83333 11.4882L2.83333 4.50016H2C1.72386 4.50016 1.5 4.27631 1.5 4.00016C1.5 3.72402 1.72386 3.50016 2 3.50016H4.83333V3.44654C4.83333 3.09044 4.83332 2.79321 4.85316 2.55038C4.87385 2.29713 4.91859 2.05936 5.03315 1.83451C5.20892 1.48955 5.48939 1.20909 5.83435 1.03332C6.05919 0.918755 6.29696 0.874015 6.55022 0.853323C6.79304 0.833483 7.09027 0.833489 7.44638 0.833496ZM3.83333 4.50016V11.4668C3.83333 12.0351 3.83372 12.4313 3.85892 12.7397C3.88364 13.0423 3.92973 13.2161 3.99682 13.3478C4.14063 13.6301 4.3701 13.8595 4.65235 14.0033C4.78403 14.0704 4.95787 14.1165 5.26045 14.1412C5.56887 14.1664 5.96503 14.1668 6.53333 14.1668H9.46667C10.035 14.1668 10.4311 14.1664 10.7395 14.1412C11.0421 14.1165 11.216 14.0704 11.3477 14.0033C11.6299 13.8595 11.8594 13.6301 12.0032 13.3478C12.0703 13.2161 12.1164 13.0423 12.1411 12.7397C12.1663 12.4313 12.1667 12.0351 12.1667 11.4668V4.50016H3.83333ZM10.1667 3.50016H5.83333V3.46683C5.83333 3.08521 5.83372 2.82907 5.84984 2.63182C5.86548 2.4404 5.8934 2.34888 5.92416 2.2885C6.00406 2.1317 6.13154 2.00422 6.28834 1.92432C6.34872 1.89356 6.44024 1.86564 6.63165 1.85C6.8289 1.83389 7.08505 1.8335 7.46667 1.8335H8.53333C8.91495 1.8335 9.1711 1.83389 9.36835 1.85C9.55976 1.86564 9.65129 1.89356 9.71166 1.92432C9.86846 2.00422 9.99594 2.1317 10.0758 2.2885C10.1066 2.34888 10.1345 2.4404 10.1502 2.63182C10.1663 2.82907 10.1667 3.08521 10.1667 3.46683V3.50016ZM6.66667 7.16683C6.94281 7.16683 7.16667 7.39069 7.16667 7.66683V11.0002C7.16667 11.2763 6.94281 11.5002 6.66667 11.5002C6.39052 11.5002 6.16667 11.2763 6.16667 11.0002V7.66683C6.16667 7.39069 6.39052 7.16683 6.66667 7.16683ZM9.33333 7.16683C9.60948 7.16683 9.83333 7.39069 9.83333 7.66683V11.0002C9.83333 11.2763 9.60948 11.5002 9.33333 11.5002C9.05719 11.5002 8.83333 11.2763 8.83333 11.0002V7.66683C8.83333 7.39069 9.05719 7.16683 9.33333 7.16683Z"
                                    fill="#DF2935"
                                  />
                                </svg>
                              </div>
                            ))}
                          </div>
                        ) : (
                          "Unavailable"
                        )}
                      </td>
                      {selectedWeekDays.includes("sat") ? (
                        <td style={{ textAlign: "right" }}>
                          <svg
                            className="pointer"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            onClick={() => {
                              setTimeRangeCount({
                                ...timeRangeCount,
                                sat: [...timeRangeCount["sat"], 0],
                              });
                              setInterviewTime({
                                ...interviewTime,
                                sat: [
                                  ...interviewTime["sat"],
                                  { from: now, to: now },
                                ],
                              });
                            }}
                          >
                            <circle cx="12" cy="12" r="12" fill="#FAFAFA" />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M11.9999 6.8335C12.2761 6.8335 12.4999 7.05735 12.4999 7.3335V11.5002H16.6666C16.9427 11.5002 17.1666 11.724 17.1666 12.0002C17.1666 12.2763 16.9427 12.5002 16.6666 12.5002H12.4999V16.6668C12.4999 16.943 12.2761 17.1668 11.9999 17.1668C11.7238 17.1668 11.4999 16.943 11.4999 16.6668V12.5002H7.33325C7.05711 12.5002 6.83325 12.2763 6.83325 12.0002C6.83325 11.724 7.05711 11.5002 7.33325 11.5002H11.4999V7.3335C11.4999 7.05735 11.7238 6.8335 11.9999 6.8335Z"
                              fill="#404040"
                            />
                          </svg>
                        </td>
                      ) : (
                        <td></td>
                      )}
                    </tr>
                  </tbody>
                </table>
              </div>
              // :
              // <div style={{ width: "100%" }}>
              //   <Multiselect
              //     options={soltsArr}
              //     onSelect={setDateRangeTime}
              //     displayValue="name"
              //     showCheckbox={true}
              //     style={{ width: "100%" }}
              //   />
              // </div>
            }
          </div>
          <div
            className="selectInterviewSlotContainer"
            style={{ display: "none" }}
          >
            <div className="selectInterviewSlotContainerHeader">
              <p className="heading">My Availiblity </p>
            </div>
            <div className="selectInterviewContainerInner">
              <div className="selectInterviewContainer">
                <Calendar onChange={onChange} value={value} />
              </div>
              <div className="selectInterviewContainer">
                <p className="month">November 2022</p>
                <div className="slotsOuter">
                  <div className="slots">
                    <div className="slot">11:00 am</div>
                    <button className="primary-btn-a">Confirm</button>
                  </div>
                  <div className="slots active">
                    <div className="slot">11:30 am</div>
                    <button className="primary-btn-a">Confirm</button>
                  </div>
                  <div className="slots">
                    <div className="slot">12:00 pm</div>
                    <button className="primary-btn-a">Confirm</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateMentorCallSlots;
